/* eslint-disable react/destructuring-assignment */
import React from 'react';
import { Button } from 'reactstrap';
import { PRESENCE_TYPE } from '../../../shared/utils/constants';
import { isNumber, textEllipsis } from '../../../shared/utils/smartutils';

export default function (t, changePresence, studentAttendance) {
  const columns = [
    {
      title: t('general.student'),
      field: 'fullName',
      cellStyle: {
        width: 9999,
        maxWidth: 9999,
        ...textEllipsis,
      },
      render: (rowData) => (
        <span className="tooltip-test" title={rowData.fullName}>
          {rowData.fullName}
        </span>
      ),
    },
  ];
  if (studentAttendance.length) {
    Object.keys(studentAttendance[0]).forEach((atr) => {
      if (isNumber(atr) && studentAttendance[0][atr]) {
        columns.push({
          title: `${atr}º ${t('general.single-class')}`,
          hidden: studentAttendance[0][atr].hidden,
          cellStyle: {
            minWidth: 150,
            maxWidth: 150,
          },
          field:
            studentAttendance[0][atr] &&
            studentAttendance[0][atr].attendanceType,
          render: (rowData) => {
            let color;
            let translation;
            const { attendanceType } = rowData[atr];
            switch (attendanceType) {
              case PRESENCE_TYPE.PRESENT:
                color = 'success';
                translation = PRESENCE_TYPE.PRESENT;
                break;
              case PRESENCE_TYPE.LACK:
                color = 'danger';
                translation = PRESENCE_TYPE.LACK;
                break;
              case PRESENCE_TYPE.JUSTIFIED:
                color = 'warning';
                translation = PRESENCE_TYPE.JUSTIFIED;
                break;
              default:
            }
            return (
              <Button
                className="m-0 w-75 btn-block"
                color={color}
                onClick={() =>
                  changePresence(
                    rowData,
                    attendanceType,
                    rowData[atr].classSequence
                  )
                }
              >
                {t(`general.student-attendance.${translation}`)}
              </Button>
            );
          },
        });
      }
    });
  }
  return columns;
}
